module.exports = __webpack_public_path__ + "img/bookmark.b47b7a0f.svg";